document.addEventListener('DOMContentLoaded', function() {

    if(window.screen.width < 767){
        var galleryProduct = new Swiper(`.product-gallery`, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 1.15,
            pagination: {
            el: '.product-gallery .swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
                },
            },
        });

        function handleFocus(e, i) {
            galleryProduct.slideTo(i);
        }

        const iconSliders = document.querySelectorAll('.product-gallery .swiper-slide');
        iconSliders.forEach((slide, i) => slide.addEventListener('focusin', (e) => handleFocus(e, i)));

    }

    document.querySelectorAll('.tabs__wrapper input').forEach(tab => {
        tab.addEventListener('click', function(){
            let value = this.value;
            document.querySelectorAll('.products-wrapper:not(.megamenu)').forEach(element => {
                element.classList.add('hidden');
            })
            document.querySelector(`[data-product-type="${value}"]`).classList.remove('hidden');
            if(value == 'hybrid'){
                if(window.screen.width < 767 && !document.querySelector('.product-gallery-hybrid').classList.contains('swiper-container-initialized')){
                var galleryProductHybrid = new Swiper(`.product-gallery-hybrid`, {
                    loop: false,
                    spaceBetween: 10,
                    slidesPerView: 1.15,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                });

                function handleFocus(e, i) {
                    galleryProductHybrid.slideTo(i);
                }

                const iconHybridSliders = document.querySelectorAll('.product-gallery-hybrid .swiper-slide');
                iconHybridSliders.forEach((slide, i) => slide.addEventListener('focusin', (e) => handleFocus(e, i)));
                }
            }
        })
    })

    let materialValue = document.querySelector('.zin-material-radio .zin-radio__input:checked')?.dataset.value;
    if(materialValue == 'Hybrid'){
        document.querySelector('#hybrid_tab-1').click();
    }else{
        document.querySelector('#memory_tab-1').click();
    }
});